import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {RuleSortPipe} from '@components/price-rules/rules-sort.pipe';
import {UserDialog} from '@components/users/user-dialog/user-dialog.component';
import {CommonModule} from '@angular/common';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {OrderTableComponent} from '@atoms/order-table/order-table.component';
import {ShipmentDialogComponent} from '@atoms/shipment-dialog/shipment-dialog.component';
import {ExtraFeesDialogComponent} from '@atoms/extra-fees/extra-fees.component';
import {ExtraFeeComponent} from '@atoms/extra-fee/extra-fee.component';
import {OrdersSectionComponent} from '@atoms/orders-section/orders-section.component';
import {NoteDetailsComponent} from '@atoms/note-details/note-details.component';
import {TextMaskModule} from 'angular2-text-mask';
import {NgSelectModule} from '@ng-select/ng-select';
import {InputFieldComponent} from '@atoms/../../components/form-fields/input-field/input-field.component';
import {SelectFieldComponent} from '@atoms/../../components/form-fields/select-field/select-field.component';
import {ValidationErrorComponent} from '@atoms/../../components/form-fields/validation-error/validation-error.component';
import {CountrySelectComponent} from '@atoms/country-select/country-select.component';
import {ButtonComponent} from '@atoms/button/button.component';
import {FormSubmittedResponseErrorComponent} from '@atoms/form-submitted-response-error/form-submitted-response-error.component';
import {ProgressOverlayComponent} from '@atoms/progress-overlay/progress-overlay.component';
import {LoadingBarOverlayComponent} from '@atoms/loading-bar-overlay/loading-bar-overlay.component';
import {RouterModule} from '@angular/router';
import {MaterialModule} from '../material/material.module';
import {DatepickerFieldComponent} from '@atoms/../../components/form-fields/datepicker-field/app-datepicker-field.component';
import {InfoCircleComponent} from '@atoms/info-circle/info-circle.component';
import {AutocompleteFieldComponent} from '@atoms/../../components/form-fields/autocomplete-field/autocomplete-field.component';
import {UserTypeComponent} from '@atoms/user-type/user-type.component';
import {RadioFieldComponent} from '@components/form-fields/radio-field/radio-field-component';
// directives
import {OnlyNumberDirective} from '@directives/only-number.directive';
import {AnimateInputDirective} from '@directives/animate-input.directive';
import {AnimateSelectDirective} from '@directives/animate-select.directive';
import {EscapeUrlPipe} from '@pipes/sanitizer';
import {DateFormatPipe} from '@pipes/date-format.pipe';
import {CurrencyFormatPipe} from '@pipes/currency-fomat.pipe';
import {NumberFormatPipe} from '@pipes/number-fomat.pipe';
import {TableComponent} from '@atoms/table/table.component';
import {PaginatorComponent} from '@atoms/paginator/paginator.component';
import {OrderInfoComponent} from '@atoms/order-info/order-info.component';
import {CardWrapperComponent} from '@modules/consignment/components/card-wrapper/card-wrapper.component';
import {NewInputFieldComponent} from '@components/form-fields/new-input-field/new-input-field.component';
import {ngxZendeskWebwidgetModule} from 'ngx-zendesk-webwidget';
import {AutocompleteAddressFieldComponent} from '@components/form-fields/autocomplete-address-field/autocomplete-address-field.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    FontAwesomeModule,
    RouterModule,
    TextMaskModule,
    NgSelectModule,
    MaterialModule,
    TranslateModule.forChild()
  ],
  declarations: [
    RuleSortPipe,
    UserDialog,
    OrderTableComponent,
    ShipmentDialogComponent,
    ExtraFeesDialogComponent,
    ExtraFeeComponent,
    OrdersSectionComponent,
    NoteDetailsComponent,
    InputFieldComponent,
    SelectFieldComponent,
    AutocompleteFieldComponent,
    AutocompleteAddressFieldComponent,
    RadioFieldComponent,
    ValidationErrorComponent,
    CountrySelectComponent,
    ButtonComponent,
    FormSubmittedResponseErrorComponent,
    ProgressOverlayComponent,
    LoadingBarOverlayComponent,
    DatepickerFieldComponent,
    InfoCircleComponent,
    UserTypeComponent,
    TableComponent,
    PaginatorComponent,
    OrderInfoComponent,
    CardWrapperComponent,
    NewInputFieldComponent,
    // directives
    AnimateInputDirective,
    AnimateSelectDirective,
    OnlyNumberDirective,
    // pipes
    EscapeUrlPipe,
    DateFormatPipe,
    CurrencyFormatPipe,
    NumberFormatPipe
  ],
  exports: [
    InputFieldComponent,
    SelectFieldComponent,
    DatepickerFieldComponent,
    AutocompleteFieldComponent,
    AutocompleteAddressFieldComponent,
    ValidationErrorComponent,
    RadioFieldComponent,
    CountrySelectComponent,
    RuleSortPipe,
    UserDialog,
    OrderTableComponent,
    OrdersSectionComponent,
    ButtonComponent,
    FormSubmittedResponseErrorComponent,
    ProgressOverlayComponent,
    LoadingBarOverlayComponent,
    InfoCircleComponent,
    UserTypeComponent,
    TableComponent,
    PaginatorComponent,
    OrderInfoComponent,
    CardWrapperComponent,
    // directives
    AnimateInputDirective,
    AnimateSelectDirective,
    OnlyNumberDirective,
    EscapeUrlPipe,
    DateFormatPipe,
    CurrencyFormatPipe,
    NumberFormatPipe,
    NewInputFieldComponent,
    ngxZendeskWebwidgetModule
  ],
  entryComponents: [
    ExtraFeesDialogComponent,
    ShipmentDialogComponent,
    NoteDetailsComponent
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts